"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function escapeSelectorFactory() {
  return function (selector) {
    var escapeSequence = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "\\";

    if (!selector) {
      return selector;
    }

    var specialCharacters = ["@"];
    var regexSpecialCharacters = ["/"];
    var regex = new RegExp("(?!@mixin)(".concat(specialCharacters.join("|"), "|\\").concat(regexSpecialCharacters.join("|\\"), ")"), "g");
    return selector.replace(regex, "".concat(escapeSequence, "$1"));
  };
}

exports.escapeSelectorFactory = escapeSelectorFactory;